/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Plannings_Stat_No_RoomsInputs */



/**
* | output |
* | --- |
* | "No occupation data in the building" |
*
* @param {Dashboard_Plannings_Stat_No_RoomsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_plannings_stat_no_rooms = /** @type {((inputs?: Dashboard_Plannings_Stat_No_RoomsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Plannings_Stat_No_RoomsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No occupation data in the building")
	return /** @type {LocalizedString} */ ("Pas de données d'occupation dans le bâtiment")
});